import type { Restaurant } from '@bilmat/shared';
import { DetourPill } from './DetourPill';
import { photoUrl } from '../lib/photoUrl';
import { formatArrivalClock, priceLabel, primaryType } from '../lib/format';

type Props = {
  restaurant: Restaurant;
  selected: boolean;
  onOpen: (placeId: string) => void;
};

export function RestaurantCard({ restaurant, selected, onOpen }: Props) {
  const img = photoUrl(restaurant.photoRef, 200);
  const meta = [
    primaryType(restaurant.types),
    priceLabel(restaurant.priceLevel),
    `🕓 Framme kl ${formatArrivalClock(restaurant.timeToReachMinutes)}`,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <button
      type="button"
      className={`rcard${selected ? ' rcard--selected' : ''}`}
      onClick={() => onOpen(restaurant.placeId)}
    >
      <div className="rcard-photo">
        <span className="rcard-photo-fallback" aria-hidden>
          🍽️
        </span>
        {/* Eager (ingen loading="lazy"): tumnaglarna är små, och lazy i sheetets
            inre scroll-container har WebKit-egenheter som inte är värda risken. */}
        {img && (
          <img
            src={img}
            alt=""
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        )}
        {restaurant.rating != null && (
          <span className="rcard-rating">★ {restaurant.rating.toFixed(1)}</span>
        )}
      </div>
      <div className="rcard-body">
        <span className="rcard-name">{restaurant.name}</span>
        <span className="rcard-meta">{meta}</span>
        <DetourPill minutes={restaurant.detourMinutes} />
      </div>
    </button>
  );
}
